import { COLOR_ACTION } from "../../config/Constants";

export const CTAButton = ({ href = "#contact", children, className = "" }) => (
  <a
    href={href}
    className={`inline-flex items-center gap-2 rounded-2xl px-5 py-3 text-sm font-semibold text-white transition
       focus:outline-none focus:ring-2 focus:ring-offset-2 ${className}`}
    style={{ backgroundColor: COLOR_ACTION }}
  >
    {children}
  </a>
);
